import React from "react";
import { concludingText, welcomingText } from "../../data/welcomingText";
import { stringToHTML } from "../../data/utils";
import FlowerExample from "../../Images/Fleur_example.png";
import "../../styles/DisplayWelcoming.css";

// Composant qui affiche le message de bienvenue, ie la page d'accueil

export const DisplayWelcoming = () => {
  return (
    <div>
      <div className="container_welcome">
        <div className="left_text">
          <div className="header">
            {welcomingText.header !== null &&
              stringToHTML(welcomingText.header)}
          </div>
          <div>{stringToHTML(welcomingText.text)}</div>
        </div>
        <img
          className="flower"
          src={FlowerExample}
          alt="FleurDeL'Agroécologie"
        ></img>
      </div>
      <div className="conclude">{stringToHTML(concludingText.text)}</div>
    </div>
  );
};
